"use strict";

exports.__esModule = true;
exports.subscriptionAdapterNotInitialized = exports.subscriptionAdapterClosed = exports.subscriptionAdapterAlreadyInitialized = void 0;
var subscriptionAdapterNotInitialized = 'Subscription adapter not initialized';
exports.subscriptionAdapterNotInitialized = subscriptionAdapterNotInitialized;
var subscriptionAdapterAlreadyInitialized = 'Subscription adapter already initialized';
exports.subscriptionAdapterAlreadyInitialized = subscriptionAdapterAlreadyInitialized;
var subscriptionAdapterClosed = 'Subscription adapter closed';
exports.subscriptionAdapterClosed = subscriptionAdapterClosed;
//# sourceMappingURL=subscribe-adapter-constants.js.map